/* eslint-disable camelcase */
/* eslint-disable no-bitwise */
// TODO: remove

import _ from 'underscore';

import { ImportOptionsForm } from '../import-options-form';


export function convertToBinaryString(number, reverse = false) {
  if (!_.isNumber(number) || number % 1 !== 0 || number < 0) {
    throw new Error('unknown data type, non-negative integers only');
  }

  let bits = [];
  let remaining = number;

  do {
    bits.push(remaining % 2);
    remaining = Math.floor(remaining / 2);
  }
  while (remaining > 0);

  if (!reverse) {
    bits = bits.reverse();
  }

  return bits.join('');
}

export function checkAgainstBitMask(selectedOptions, exp) {
  const optionsInBinary = convertToBinaryString(selectedOptions, true);

  return optionsInBinary.charAt(exp) === '1';
}

function parseImportNewOptions(importNewOptions) {
  const checkNewOptions = _.partial(checkAgainstBitMask, importNewOptions);

  /* eslint-disable max-len */
  // Get the enum value from
  // private/Campaign/MT/Source/BingAds.Api.NetCore/BingAds.Api.Model.NetCore/Import/ImportNewOption.cs
  /* eslint-enable max-len */
  return {
    ImportNewActiveEntitiesOnly: checkNewOptions(0),
    ImportNewCampaignsAndMarkAsPaused: checkNewOptions(1),
    ImportNewCampaignsAndChildEntities: checkNewOptions(2),
    ImportNewAdGroupsAndChildEntitiesForExistingCampaigns: checkNewOptions(3),
    ImportNewAdsForExistingAdGroups: checkNewOptions(4),
    ImportNewKeywordsForExistingAdGroups: checkNewOptions(5),
    ImportNewNegativeKeywordsForExistingParents: checkNewOptions(6),
    ImportNewNegativeKeywordList: checkNewOptions(7),
    ImportNewLocationTargets: checkNewOptions(8),
    ImportNewAppAdExtensions: checkNewOptions(12),
    ImportNewDayTimeTargets: checkNewOptions(9),
    ImportNewDeviceTargets: checkNewOptions(10),
    ImportNewDemographicTargets: checkNewOptions(11),
    ImportNewCallAdExtensions: checkNewOptions(13),
    ImportNewCalloutAdExtensions: checkNewOptions(14),
    ImportNewLocationAdExtensions: checkNewOptions(16),
    ImportNewPriceAdExtensions: checkNewOptions(15),
    ImportNewPromotionAdExtensions: checkNewOptions(27),
    ImportNewReviewAdExtensions: checkNewOptions(17),
    ImportNewSitelinkAdExtensions: checkNewOptions(18),
    ImportNewStructuredSnippetAdExtensions: checkNewOptions(19),
    ImportNewKeywordUrls: checkNewOptions(20),
    ImportNewTrackingTemplateAndCustomParams: checkNewOptions(21),
    ImportNewNegativeSites: checkNewOptions(22),
    ImportNewPageFeeds: checkNewOptions(23),
    ImportNewAudienceTargets: checkNewOptions(24),
    ImportNewAdCustomizerFeeds: checkNewOptions(25),
    ImportAllAdUnderAnAdGroup: checkNewOptions(26),
    ImportNewImageAdExtensions: checkNewOptions(28),
  };
}

function parseImportUpdateOptions(importUpdateOptions) {
  const checkUpdateOptions = _.partial(checkAgainstBitMask, importUpdateOptions);

  /* eslint-disable max-len */
  // Get the enum value from
  // private/Campaign/MT/Source/BingAds.Api.NetCore/BingAds.Api.Model.NetCore/Import/ImportUpdateOption.cs
  /* eslint-enable max-len */
  return {
    CampaignBudgets: checkUpdateOptions(0),
    AdGroupKeywordBids: checkUpdateOptions(1),
    NegativeKeywordLists: checkUpdateOptions(16),
    NegativeSites: checkUpdateOptions(3),
    KeywordDestinationUrls: checkUpdateOptions(7),
    TrackingTemplateCustomParams: checkUpdateOptions(8),
    LocationTargeting: checkUpdateOptions(4),
    AdExtensions: checkUpdateOptions(6),
    UpdateStatusForExistingCampaigns: checkUpdateOptions(9),
    UpdateStatusForExistingAds: checkUpdateOptions(13),
    UpdateStatusForExistingKeywords: checkUpdateOptions(15),
    UpdateStatusForExistingAdGroups: checkUpdateOptions(17),
    UpdateNameForExistingCampaigns: checkUpdateOptions(10),
    UpdateLanguageForExistingAdGroups: checkUpdateOptions(19),
    UpdateDayTimeTargets: checkUpdateOptions(20),
    UpdateDeviceTargets: checkUpdateOptions(21),
    UpdateDemographicTargets: checkUpdateOptions(22),
    UpdateAppAdExtensions: checkUpdateOptions(23),
    UpdateCallAdExtensions: checkUpdateOptions(24),
    UpdateCalloutAdExtensions: checkUpdateOptions(25),
    UpdateLocationAdExtensions: checkUpdateOptions(27),
    UpdatePriceAdExtensions: checkUpdateOptions(26),
    UpdatePromotionAdExtensions: checkUpdateOptions(35),
    UpdateReviewAdExtensions: checkUpdateOptions(28),
    UpdateSitelinkAdExtensions: checkUpdateOptions(29),
    UpdateStructuredSnippetAdExtensions: checkUpdateOptions(30),
    UpdateAdGroupNetworkSetting: checkUpdateOptions(31),
    UpdatePageFeeds: checkUpdateOptions(32),
    UpdateAudienceTargets: checkUpdateOptions(33),
    UpdateAdCustomizerFeeds: checkUpdateOptions(34),
    UpdateImageAdExtensions: checkUpdateOptions(36),
  };
}

export function parseExistingImportOptions(deps, existingOptions) {
  const options = _.clone(existingOptions);
  const storeListLength =
    deps.storeList && deps.storeList.length;
  const firstStoreInList = storeListLength > 0 && _.first(deps.storeList).Value;
  const initialStoreId =
    options.StoreIdForImportedProductAdExtensions
    || (firstStoreInList && parseInt(firstStoreInList, 10));
  const storeIds = _.map(_.pluck(deps.storeList, 'Value'), id => parseInt(id, 10));

  const importNewOptions = parseImportNewOptions(options.ImportNewOptions);
  const importUpdateOptions =
    parseImportUpdateOptions(options.UpdateEntityPreferences.ImportUpdateOptions);
  const isPageFeedEnabled = ImportOptionsForm.isPageFeedEnabled(deps);

  const isDeviceTargetOptimizationEnabled
    = ImportOptionsForm.isDeviceTargetOptimizationEnabled(deps);

  const isAdScheduleUseSearcherTimezoneEnabled
    = ImportOptionsForm.isAdScheduleUseSearcherTimezoneEnabled(deps);

  const isPauseAIMAdGroupIfAllAudienceCriterionNotImportedImportOptionEnabled
    = ImportOptionsForm.isPauseAIMAdGroupIfAllAudienceCriterionNotImportedImportOptionEnabled(deps);

  const isGoogleImageExtensionImportOptionEnabled
    = ImportOptionsForm.isGoogleImageExtensionImportOptionEnabled(deps);

  const isAudienceTargetForFBImportOptionEnabled
    = ImportOptionsForm.isAudienceTargetForFBImportOptionEnabled(deps);

  let mappedOptions = {
    TrackingTemplateValue: options.TrackingTemplateValue,
    ImportAccountUrlOptions: !!options.UserSetProperties2,
    // ImportNewItems
    ImportNewEntities: options.ImportNewEntities,
    // flag is flipped in UI
    ImportNewOption_ImportNewActiveEntitiesOnly:
      !importNewOptions.ImportNewActiveEntitiesOnly,
    ImportNewOption_ImportNewCampaignsAndMarkAsPaused:
      importNewOptions.ImportNewCampaignsAndMarkAsPaused,
    ImportNewOption_ImportNewCampaignsAndChildEntities:
      importNewOptions.ImportNewCampaignsAndChildEntities,
    ImportNewOption_ImportNewAdGroupsAndChildEntitiesForExistingCampaigns:
      importNewOptions.ImportNewAdGroupsAndChildEntitiesForExistingCampaigns,
    ImportNewOption_ImportNewAdsForExistingAdGroups:
      importNewOptions.ImportNewAdsForExistingAdGroups,
    ImportNewOption_ImportNewKeywordsForExistingAdGroups:
      importNewOptions.ImportNewKeywordsForExistingAdGroups,
    ImportNewOption_ImportNewNegativeKeywordsForExistingParents:
      importNewOptions.ImportNewNegativeKeywordsForExistingParents,
    ImportNewOption_ImportNewNegativeKeywordList:
      importNewOptions.ImportNewNegativeKeywordList,
    ImportNewOption_ImportNewLocationTargets:
      importNewOptions.ImportNewLocationTargets,
    ImportNewOption_ImportNewAppAdExtensions:
      importNewOptions.ImportNewAppAdExtensions,
    // ExistingItems
    UpdateEntityPreferences: options.UpdateEntityPreferences.ImportUpdatedEntities,
    ImportUpdateEntityPreference_UpdateCampaignBudget:
      importUpdateOptions.CampaignBudgets,
    ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBids:
      importUpdateOptions.AdGroupKeywordBids,
    ImportUpdateEntityPreference_UpdateExistingNegativeKeywordList:
      importUpdateOptions.NegativeKeywordLists,
    ImportUpdateEntityPreference_UpdateNegativeSites:
      importUpdateOptions.NegativeSites,
    ImportUpdateEntityPreference_UpdateKeywordDestinationUrl:
      importUpdateOptions.KeywordDestinationUrls,
    ImportUpdateEntityPreference_UpdateTrackingTemplateAndCustomParams:
      importUpdateOptions.TrackingTemplateCustomParams,
    ImportUpdateEntityPreference_UpdateLocationTargets:
      importUpdateOptions.LocationTargeting,
    ImportUpdateEntityPreference_UpdateAdExtensions: importUpdateOptions.AdExtensions,
    ImportUpdateEntityPreference_UpdateStatusForExistingCampaigns:
      importUpdateOptions.UpdateStatusForExistingCampaigns,
    ImportUpdateEntityPreference_UpdateStatusForExistingAds:
      importUpdateOptions.UpdateStatusForExistingAds,
    ImportUpdateEntityPreference_UpdateStatusForExistingKeywords:
      importUpdateOptions.UpdateStatusForExistingKeywords,
    ImportUpdateEntityPreference_UpdateStatusForExistingAdGroups:
      importUpdateOptions.UpdateStatusForExistingAdGroups,
    ImportUpdateEntityPreference_UpdateLanguageForExistingAdGroups:
      importUpdateOptions.UpdateLanguageForExistingAdGroups,
    // DeletedItems
    ImportDeletedEntities: options.ImportDeletedEntities,
    // BidsAndBudgets
    DefaultBidsBelowMinToAdCenterMinBid: options.DefaultBidsBelowMinToAdCenterMinBid,
    DefaultCampaignBudgetBelowMinToAdCenterMinBudget:
      options.DefaultCampaignBudgetBelowMinToAdCenterMinBudget,
    // OtherItems
    ImportAppendDestUrlPreference_UseAppendString: options.AppendDestUrlPreference.UseAppendString,
    ImportAppendDestUrlPreference_AppendStringForDestinationUrl:
      options.AppendDestUrlPreference.UseAppendString ?
        options.AppendDestUrlPreference.AppendStringForDestinationUrl : '',
    ImportSearchAndReplaceDestUrlPreference_UseSearchAndReplaceString:
      options.SearcAndReplaceDestUrlPreference.UseSearchAndReplaceString,
    ImportSearchAndReplaceDestUrlPreference_SearchStringForDestinationUrl:
      options.SearcAndReplaceDestUrlPreference.UseSearchAndReplaceString ?
        options.SearcAndReplaceDestUrlPreference.SearchStringForDestinationUrl : '',
    ImportSearchAndReplaceDestUrlPreference_ReplaceStringForDestinationUrl:
      options.SearcAndReplaceDestUrlPreference.ReplaceStringForDestinationUrl,
    AppendPreferencesForTrackingTemplate_UseAppendString:
      options.AppendTrackingTemplatePreference.UseAppendString,
    AppendPreferencesForTrackingTemplate_AppendStringForTrackingTemplate:
      options.AppendTrackingTemplatePreference.UseAppendString ?
        options.AppendTrackingTemplatePreference.AppendStringForTrackingTemplate : '',
    SearchAndReplacePreferencesForTrackingTemplate_UseSearchAndReplaceString:
      options.SearchAndReplaceTrackingTemplatePreference.UseSearchAndReplaceString,
    SearchAndReplacePreferencesForTrackingTemplate_SearchStringForTrackingTemplate:
      options.SearchAndReplaceTrackingTemplatePreference.UseSearchAndReplaceString ?
        options.SearchAndReplaceTrackingTemplatePreference.SearchStringForTrackingTemplate : '',
    SearchAndReplacePreferencesForTrackingTemplate_ReplaceStringForTrackingTemplate:
      options.SearchAndReplaceTrackingTemplatePreference.ReplaceStringForTrackingTemplate,

    // behavior for option is opposite of the enum name (if checked, don't pass back this value)
    ImportUpdateEntityPreference_UpdateNameForExistingCampaigns:
      !importUpdateOptions.UpdateNameForExistingCampaigns,
    // check this option if there's only one store id
    StoreIdForImportedProductAdExtensionsFlag:
      !!options.StoreIdForImportedProductAdExtensions || (storeListLength === 1),
    StoreIdForImportedProductAdExtensions: initialStoreId,
    AvailableStoreValues: storeIds,
    AvailableStoreValueMessages: _.pluck(deps.storeList, 'Text'),
    // import options v2 options:
    ImportNewOption_ImportNewDayTimeTargets: importNewOptions.ImportNewDayTimeTargets,
    ImportNewOption_ImportNewDeviceTargets: importNewOptions.ImportNewDeviceTargets,
    ImportNewOption_ImportNewDemographicTargets: importNewOptions.ImportNewDemographicTargets,
    ImportNewOption_ImportNewCallAdExtensions: importNewOptions.ImportNewCallAdExtensions,
    ImportNewOption_ImportNewCalloutAdExtensions: importNewOptions.ImportNewCalloutAdExtensions,
    ImportNewOption_ImportNewLocationAdExtensions: importNewOptions.ImportNewLocationAdExtensions,
    ImportNewOption_ImportNewPriceAdExtensions: importNewOptions.ImportNewPriceAdExtensions,
    ImportNewOption_ImportNewPromotionAdExtensions: importNewOptions.ImportNewPromotionAdExtensions,
    ImportNewOption_ImportNewReviewAdExtensions: importNewOptions.ImportNewReviewAdExtensions,
    ImportNewOption_ImportNewSitelinkAdExtensions: importNewOptions.ImportNewSitelinkAdExtensions,
    ImportNewOption_ImportNewStructuredSnippetAdExtensions:
      importNewOptions.ImportNewStructuredSnippetAdExtensions,
    ImportUpdateEntityPreference_UpdateDayTimeTargets: importUpdateOptions.UpdateDayTimeTargets,
    ImportUpdateEntityPreference_UpdateDeviceTargets: importUpdateOptions.UpdateDeviceTargets,
    ImportUpdateEntityPreference_UpdateDemographicTargets:
      importUpdateOptions.UpdateDemographicTargets,
    ImportUpdateEntityPreference_UpdateAppAdExtensions: importUpdateOptions.UpdateAppAdExtensions,
    ImportUpdateEntityPreference_UpdateCallAdExtensions:
      importUpdateOptions.UpdateCallAdExtensions,
    ImportUpdateEntityPreference_UpdateCalloutAdExtensions:
      importUpdateOptions.UpdateCalloutAdExtensions,
    ImportUpdateEntityPreference_UpdateLocationAdExtensions:
      importUpdateOptions.UpdateLocationAdExtensions,
    ImportUpdateEntityPreference_UpdatePriceAdExtensions:
      importUpdateOptions.UpdatePriceAdExtensions,
    ImportUpdateEntityPreference_UpdatePromotionAdExtensions:
      importUpdateOptions.UpdatePromotionAdExtensions,
    ImportUpdateEntityPreference_UpdateReviewAdExtensions:
      importUpdateOptions.UpdateReviewAdExtensions,
    ImportUpdateEntityPreference_UpdateSitelinkAdExtensions:
      importUpdateOptions.UpdateSitelinkAdExtensions,
    ImportUpdateEntityPreference_UpdateStructuredSnippetAdExtensions:
      importUpdateOptions.UpdateStructuredSnippetAdExtensions,
    ImportPrefixAndSuffixForStringProperty_EnablePrefixAndSuffix:
      !!options.PrefixAndSuffixForCampaignNames &&
      options.PrefixAndSuffixForCampaignNames.EnablePrefixAndSuffix,
    ImportPrefixAndSuffixForStringProperty_SuffixString:
      options.PrefixAndSuffixForCampaignNames &&
        options.PrefixAndSuffixForCampaignNames.EnablePrefixAndSuffix ?
        options.PrefixAndSuffixForCampaignNames.SuffixString : '',
    ImportSearchAndReplaceForStringProperty_EnableSearchAndReplace:
      !!options.SearchAndReplaceForCampaignNames &&
      options.SearchAndReplaceForCampaignNames.EnableSearchAndReplace,
    ImportSearchAndReplaceForStringProperty_SearchString:
      !!options.SearchAndReplaceForCampaignNames &&
        options.SearchAndReplaceForCampaignNames.EnableSearchAndReplace ?
        options.SearchAndReplaceForCampaignNames.SearchString : '',
    ImportSearchAndReplaceForStringProperty_ReplaceString:
      options.SearchAndReplaceForCampaignNames ?
        options.SearchAndReplaceForCampaignNames.ReplaceString : '',

    PauseAdGroupIfNoLocationSupported: options.PauseAdGroupIfNoLocationSupported,
    EnableAutoCurrencyConversion: options.EnableAutoCurrencyConversion,
  };

  mappedOptions = _.extend(mappedOptions, {
    ImportNewOption_ImportNewKeywordUrls: importNewOptions.ImportNewKeywordUrls,
    ImportNewOption_ImportNewTrackingTemplateAndCustomParams:
      importNewOptions.ImportNewTrackingTemplateAndCustomParams,
    ImportNewOption_ImportNewNegativeSites: importNewOptions.ImportNewNegativeSites,
    ImportUpdateEntityPreference_UpdateAdGroupNetworkSetting:
      importUpdateOptions.UpdateAdGroupNetworkSetting,
    AdjustmentForBids_EnableAdjustment:
      options.AdjustmentForBids ? options.AdjustmentForBids.EnableAdjustment : false,
    AdjustmentForBids_AdjustmentValue:
      (options.AdjustmentForBids && options.AdjustmentForBids.AdjustmentValue) || 0,
    AdjustmentForCampaignBudgets_EnableAdjustment:
      options.AdjustmentForCampaignBudgets ?
        options.AdjustmentForCampaignBudgets.EnableAdjustment : false,
    AdjustmentForCampaignBudgets_AdjustmentValue:
      (options.AdjustmentForCampaignBudgets
        && options.AdjustmentForCampaignBudgets.AdjustmentValue) || 0,
    PauseParentIfNoLocationSupported: options.PauseParentIfNoLocationSupported,
    EnableParentLocationMapping: options.EnableParentLocationMapping === false,
  });

  mappedOptions = _.extend(mappedOptions, {
    FinalUrlSuffixValue: options.FinalUrlSuffixValue,
  });

  mappedOptions = _.extend(mappedOptions, {
    RaiseLowBidsToMinServingBidsForBsc: options.RaiseLowBidsToMinServingBidsForBsc,
  });

  if (isDeviceTargetOptimizationEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      AutoDeviceBidOptimization: options.AutoDeviceBidOptimization,
    });
  }

  if (isAdScheduleUseSearcherTimezoneEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      AdScheduleUseSearcherTimezone: options.AdScheduleUseSearcherTimezone,
    });
  }

  if (isPauseAIMAdGroupIfAllAudienceCriterionNotImportedImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      PauseAIMAdGroupIfAllAudienceCriterionNotImported:
        options.PauseAIMAdGroupIfAllAudienceCriterionNotImported,
    });
  }

  if (isGoogleImageExtensionImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewImageAdExtensions:
        importNewOptions.ImportNewImageAdExtensions,
      ImportUpdateEntityPreference_UpdateImageAdExtensions:
        importUpdateOptions.UpdateImageAdExtensions,
    });
  }

  mappedOptions = _.extend(mappedOptions, {
    ImportSearchAndDsaMixedCampaignAsSearchCampaign:
      options.ImportSearchAndDsaMixedCampaignAsSearchCampaign,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportNewOption_ImportNewAudienceTargets: importNewOptions.ImportNewAudienceTargets,
    ImportUpdateEntityPreference_UpdateAudienceTargets: importUpdateOptions.UpdateAudienceTargets,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportUET: importNewOptions.ImportNewAudienceTargets && !!options.AssociatedUETTagId,
    AssociatedUETTagId: options.AssociatedUETTagId || '',
  });

  if (isAudienceTargetForFBImportOptionEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      NoAudienceTargetForFBImportOption:
        !options.ImportNewAudienceTargets && !options.UpdateAudienceTargets,
    });
  }

  mappedOptions = _.extend(mappedOptions, {
    SearchAndReplaceForCustomParameters_EnableSearchAndReplace:
        options.SearchAndReplaceForCustomParameters.EnableSearchAndReplace,
    SearchAndReplaceForCustomParameters_SearchString:
        options.SearchAndReplaceForCustomParameters.SearchString,
    SearchAndReplaceForCustomParameters_ReplaceString:
        options.SearchAndReplaceForCustomParameters.ReplaceString,
  });

  mappedOptions = _.extend(mappedOptions, {
    SearchAndReplaceForFinalURLSuffix_EnableSearchAndReplace:
        options.SearchAndReplaceForFinalURLSuffix.EnableSearchAndReplace,
    SearchAndReplaceForFinalURLSuffix_SearchString:
        options.SearchAndReplaceForFinalURLSuffix.SearchString,
    SearchAndReplaceForFinalURLSuffix_ReplaceString:
        options.SearchAndReplaceForFinalURLSuffix.ReplaceString,
  });

  if (isPageFeedEnabled) {
    mappedOptions = _.extend(mappedOptions, {
      ImportNewOption_ImportNewPageFeeds: importNewOptions.ImportNewPageFeeds,
      ImportUpdateEntityPreference_UpdatePageFeeds: importUpdateOptions.UpdatePageFeeds,
    });
  }

  mappedOptions = _.extend(mappedOptions, {
    ImportNewOption_ImportAllAdUnderAnAdGroup: importNewOptions.ImportAllAdUnderAnAdGroup,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportNewLabelsAndAssociations:
      (options.ImportNewLabelsAndAssociations != null)
        ? options.ImportNewLabelsAndAssociations
        : options.ImportNewEntities,
    UpdateLabelsAndAssociations:
      (options.UpdateLabelsAndAssociations != null)
        ? options.UpdateLabelsAndAssociations
        : options.UpdateEntityPreferences.ImportUpdatedEntities,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportNewCustomFiltersForShoppingCampaigns:
      (options.ImportNewCustomFiltersForShoppingCampaigns != null)
        ? options.ImportNewCustomFiltersForShoppingCampaigns
        : options.ImportNewEntities,
    UpdateCustomFiltersForShoppingCampaigns:
      (options.UpdateCustomFiltersForShoppingCampaigns != null)
        ? options.UpdateCustomFiltersForShoppingCampaigns
        : options.UpdateEntityPreferences.ImportUpdatedEntities,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportNewOption_ImportNewAdCustomizerFeeds: importNewOptions.ImportNewAdCustomizerFeeds,
    ImportUpdateEntityPreference_UpdateAdCustomizerFeeds:
      importUpdateOptions.UpdateAdCustomizerFeeds,
  });

  mappedOptions = _.extend(mappedOptions, {
    ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBidStrategies:
      !!options.UpdateBiddingStrategies,
  });

  return mappedOptions;
}
